export const environment = {
  production: false,
  apiRoot: '/api',
  clientId: '9ea2e3b2-3746-4215-b396-f05e33ecae09',
  authority: 'https://login.microsoftonline.com/428f4e2e-13bf-4884-b364-02ef9af41a1d',
  redirectUri: 'https://dev-sisapp.s2plus.online/agricola',
  postLogoutRedirectUri: 'https://dev-sisapp.s2plus.online/',
  assistancePaymentPublicUrl: 'https://dev-sisapp.s2plus.online',
  apiScopes: ['api://f3eddc11-a8b4-4abc-ab7a-ed075043a9c9/FrontEnd.SIS'],
  firebase: {
    apiKey: 'AIzaSyC0_liCDxSIeMX8rPbBuC8Rhol8glV9xrA',
    authDomain: 'apolo11-dev.firebaseapp.com',
    databaseURL: 'https://apolo11-dev-default-rtdb.firebaseio.com/',
    projectId: 'apolo11-dev',
    storageBucket: 'apolo11-dev.appspot.com',
    messagingSenderId: '97185667284',
    appId: '1:97185667284:web:b67f8c5d9dce2e3662c341'
  }
};